jQuery(document).ready(function ($) {
    const $window = $(window);
    const $document = $(document);

    const template = $('#exit-popup-tpl').html();

    if (!template || !template.length) {
        return;
    }

    let alreadyOpened = false;
    const markup = $(template).hide();
    const config = markup.data('config');
    const storageHash = `postpone-exit-popup-${config.hash}`;

    if ((Date.now() - (window.localStorage.getItem(storageHash) || 0)) <= (config.reopen_after * 1000)) {
        return;
    }

    const track = (eventAction) => {
        if (typeof ga === 'undefined') {
            return;
        }

        ga('send', {
            hitType: 'event',
            eventCategory: 'Exit Popup',
            eventAction: eventAction,
            eventLabel: `Exit Popup ${config.variant}`
        });
    };

    const open = () => {
        track('open');
        $(window).off('scroll.exit-popup');

        if (alreadyOpened) {
            return;
        }

        alreadyOpened = true;
        $('body').append(markup);
        $('.js-exit-popup').fadeIn('slow');

        iFrameResize({log: false});
    };

    const close = (withTracking = true) => {
        $('.js-exit-popup').fadeOut('slow');

        window.localStorage.setItem(storageHash, `${Date.now()}`);

        if (withTracking) {
            track('close');
        }
    };

    const scrollRAF = () => {
        const triggerPos = ($document.height() * config.scroll_delay_percent) / 100 - $window.height();
        if (triggerPos < $window.scrollTop()) {
            open();
        }
    };

    if (config.trigger === 'scroll') {
        $(window).on('scroll.exit-popup', () => {
            window.requestAnimationFrame(scrollRAF);
        });
    } else if (config.trigger === 'time') {
        window.setTimeout(open, config.delay_in_seconds);
    } else {
        ouibounce(false, {
            callback: open
        });
    }

    $(document).on('click', '.js-exit-popup--close', close);

    window.addEventListener('message', (event) => {
        if (!event.origin.match(/extensis(group|hr).com$/)) {
            return;
        }

        if (!event.data.action || event.data.action !== 'pardot-close-modal') {
            return;
        }

        track('submit');
        close(false);
    });
});